<template>
<div>
  <v-container fill-height
                px-0
               fluid>
    <v-layout row wrap>
      <v-flex lg12
              md12
              xs12>
          <!-- iten-key属性需要具有唯一性 -->
          <v-data-table :expand="expand"
                        :headers="tableHeaders"
                        :items="tableDesserts"
                        :loading="loading"
                         hide-actions
                        class="common-table"
                        item-key="Date"
                        :noDataText="noDataText">
            <!-- <v-progress-linear color="blue"
                               indeterminate
                               v-slot:progress></v-progress-linear> -->
            <template v-slot:items="props">
              <tr @click="props.expanded = !props.expanded;dateId = props.item.Date"
                  :style="{'background-color': props.expanded ?'#E9F4FF !important':'','color': props.expanded ?'#32397A':''}">
                <td>{{props.item.Date| formatDate}} &nbsp; Growth Report &nbsp; <span class="blue-text-light">({{ props.item.DateStr}})</span></td>
                <td class="text-xs-right">
                    <v-btn class="text-none blue-border-button" v-if="show" @click.stop="downloadReport(props.item.Date,props.item.DateStr)">Download</v-btn>
                    <v-icon class="blue-text-light">{{props.expanded?'expand_less':'expand_more'}}</v-icon>
                </td>
              </tr>
            </template>
            <template slot="expand">
              <div>
                  <table class="fix-table-hover">
                      <tr>
                          <td class="font-weight-bold">Praiseworthy</td>
                          <td class="font-weight-bold">To be improved</td>
                      </tr>
                      <tr v-for="(v,i) in praiseworthyList" :key="i">
                          <td>
                              <span v-if="v" class="list-name">
                                  {{v.Name}}&#8195;{{v.Value}}
                              </span>
                              <span v-if="v" class="persent">
                                    <span v-if="v.IsLastZero">--</span>
                                    <template v-else>
                                        <span v-if="v.Value==0" class="green-text">
                                            <img src="../../assets/img/ranking/arrow-up.png" alt="" />{{v.Persent*100}}%
                                        </span>
                                        <span v-else-if="v.Persent>=0" class="red-text">
                                            <img src="../../assets/img/ranking/arrow-down.png" alt="" />{{v.Persent | formateV}}%
                                        </span>
                                        <span v-else class="green-text">
                                            <img src="../../assets/img/ranking/arrow-up.png" alt="" />{{v.Persent | formateV}}%
                                        </span>
                                    </template>
                                </span>
                          </td>
                          <td>
                                <span v-if="improvedList[i]" class="list-name">
                                    {{improvedList[i].Name}}&#8195;{{improvedList[i].Value}}
                                </span>
                                <span v-if="improvedList[i]" class="persent">
                                    <span v-if="improvedList[i].IsLastZero">--</span>
                                    <template v-else>
                                        <span v-if="improvedList[i].Value==0" class="green-text">
                                            <img src="../../assets/img/ranking/arrow-up.png" alt="" />{{improvedList[i].Persent*100}}%
                                        </span>
                                        <span v-else-if="improvedList[i].Persent>=0" class="red-text">
                                            <img src="../../assets/img/ranking/arrow-down.png" alt="" />{{improvedList[i].Persent | formateV}}%
                                        </span>
                                        <span v-else class="green-text">
                                            <img src="../../assets/img/ranking/arrow-up.png" alt="" />{{improvedList[i].Persent | formateV}}%
                                        </span>
                                    </template>
                                    <span v-if="improvedList[i].Content" @click="checkImproveIdea(improvedList[i].Content)">
                                        <img slot="activator" src="../../assets/img/dashboard/growth-system/lightbulb.png" alt="" />
                                    </span>
                                </span>
                          </td>
                          
                      </tr>
                  </table>
              </div>
            </template>
          </v-data-table>
          <div class="text-xs-left pt-4">
            <!-- <v-pagination class="common-pagination"
                        v-model="pagination.pageIndex"
                        @input="search"
                        :total-visible="pagination.totalVisible"
                        :length="pagination.totalPages"></v-pagination> -->
          </div>
      </v-flex>
        <v-flex v-if="growthSystemLevel<2" xs12 class="text-xs-center blue-title">
            <img src="../../assets/img/dashboard/growth-system/growth-report.png" alt="" />
            <p class="font-weight-bold">No Data!</p>
            <p>When you reach Level 2 (LV.2), you will receive a<br>
                growth report every two weeks.</p>
            <v-btn class="text-none blue-button" to="/growthCenter">
                Level Up!
            </v-btn> 
        </v-flex>
    </v-layout>
  </v-container>
    <iframe v-if="renderReport" src="/growthReport.html" frameborder="0" style="width:100%;height:0" id="reportIframe"></iframe>
  </div>
</template>

<script>
import { getStrengthAssessment } from '@/api/dashboard'
import { formatDate } from '@/utils/date.js'
import store from 'store2'
import { downloadPDF } from '@/utils/htmlToPdf.js'
export default {
  data: () => ({
    expand: false,
    // pagination: {
    //   pageIndex: 1,
    //   pageSize: 10,
    //   totalVisible: 7,
    //   totalPages: 0
    // },
    tableHeaders: [
        {
        text: 'Growth Report',
        align: 'left',
        sortable: false,
        value: 'DateStr'
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: 'issueDate'
      },
    ],
    tableDesserts: [],
    loading: false,
    dateId:null,
    improvedList:[],
    praiseworthyList:[],
    renderReport:false,
    show: false,
  }),
  mounted () {
    if(this.growthSystemLevel>1){
      this.search(true,'2021-05-01T00:00:00')
    }
    // 埋点
    this.$store.dispatch('GrowthRequestLog',{logType:1,content:location.href})
  },
  filters: {
    formatDate (time) {
      let date = new Date(time)
      return formatDate(date, 'MM/dd')
    },
    formateV(v){
        return Math.abs(v*100).toFixed(2)
    }
  },
  computed: {
    noDataText () {
      return this.loading ? 'Loading...' : 'No Data'
    },
    growthSystemLevel(){
      return this.$store.state.user.growthSystemLevel
    },
  },
  methods: {
    search (boo,date) {
        this.loading = true
        getStrengthAssessment(boo,date).then(res=>{
            if(res){
              this.show = res.IsDownLoad;
                if(res.TimeList){
                    this.tableDesserts = res.TimeList
                    this.IsDownLoad = res.IsDownLoad
                }
                if(res.ImprovedList){
                    this.improvedList = res.ImprovedList || []
                    this.praiseworthyList = res.PraiseworthyList || []
                    let len1 = this.improvedList.length
                    let len2 = this.praiseworthyList.length
                    let max = Math.max(len1,len2)
                    if(len1 < max){
                        let ary = new Array(max-len1).fill(null)
                        this.improvedList = [...this.improvedList,...ary]
                    }
                    if(len2 < max){
                        let ary = new Array(max-len2).fill(null)
                        this.praiseworthyList = [...this.praiseworthyList,...ary]
                    }
                }
            }
        }).finally(() => {
            this.loading = false
        })
    },
    checkImproveIdea(text){
        this.$root.$alertTips(text,'default')
    },
    async downloadReport(date,dateStr){
      // 埋点
      this.$store.dispatch('GrowthRequestLog',{logType:6});

      this.renderReport = false;
      await getStrengthAssessment(false,date).then(res=>{
        if(res){
          let obj = {
            praise:res.PraiseworthyList || [],
            improved:res.ImprovedList || [],
            dateStr
          }
          store.set('growthReport',obj)
          this.renderReport = true
        }
      })
      var iframe = document.querySelector('#reportIframe');
      if (iframe.attachEvent) {
          iframe.attachEvent("onload", function() {
            var ele = iframe.contentWindow.document.getElementById("growthReportContainer")
            downloadPDF(ele, 'GrowthReport')
          });
      } else {
        iframe.onload = function() {
          var ele = iframe.contentWindow.document.getElementById("growthReportContainer")
          downloadPDF(ele, 'GrowthReport')
        }
      }
      
    }
  },
  watch:{
    dateId:function(v){
      this.improvedList = [];
        this.praiseworthyList = [];
      this.search(false,v)
    }
  },
  beforeRouteLeave(to, from, next){
    this.$store.dispatch('GrowthUpdateLogTime',{content:location.href})
    next()
  }
}
</script>
<style>
/* 去除历史工资记录表格的下边框 */
.theme--light.v-datatable .v-datatable__expand-col--expanded{
	border-bottom: none;
}
  /* .v-card__text.blue-title.align-center a{
    display: block;
    width:100% !important;
    text-align: left;
    background-color: rgb(255, 239, 239) !important;
  } */
</style>
<style lang="scss" scoped>
  // 修改默认
  //本来想统一使用默认的颜色，可是rowspan的单元格产生了边距颜色加深的问题
  .fix-table-hover{
    border-bottom: 10px solid #E9F4FF !important;
    border-collapse: collapse;
    width: 100%;
    .list-name{
        display:inline-block;
        width:300px;
    }
    .persent>span{
        display:inline-block;
        width:100px;
        .v-tooltip{
            img{
                vertical-align: middle;
            }
        }
    }
    .green-text{
        color:#30BF78;
        img{
            height: 15px;
            transform: rotate(90deg) translateX(6px);
        }
    }
    .red-text{
        color:#EE344C;
        img{
            height: 15px;
            transform: rotate(-90deg);
        }
    }
  }
  .fix-table-hover .theme--light.v-table tbody tr:not(:last-child) {
    border: none;
  }
  .fix-table-hover .theme--light.v-table tbody tr:not(:last-child) td {
    border: 1px solid rgba(224, 224, 224, 0.5);
  }
  .fix-table-hover td {
    border: 1px solid rgba(224, 224, 224, 0.5);
  }
  .fix-table-hover
    .theme--light.v-table
    tbody
    tr:hover:not(.v-datatable__expand-row) {
        @include bg_color($background-color-theme);

  }
  .fix-table-hover .v-datatable tbody tr{
    color: #32397A !important;
    &:hover{
      background-color: #FFF!important;
    }
  }
</style>
